__turbopack_context__.v({
  "header": "TaxYearlyReportListSupplemental-module-scss-module__ZFQVQq__header",
  "impactWrapper": "TaxYearlyReportListSupplemental-module-scss-module__ZFQVQq__impactWrapper",
  "mobileListHeader": "TaxYearlyReportListSupplemental-module-scss-module__ZFQVQq__mobileListHeader",
  "orgInfo": "TaxYearlyReportListSupplemental-module-scss-module__ZFQVQq__orgInfo",
  "printLink": "TaxYearlyReportListSupplemental-module-scss-module__ZFQVQq__printLink",
  "summation": "TaxYearlyReportListSupplemental-module-scss-module__ZFQVQq__summation",
  "taxMessageInfo": "TaxYearlyReportListSupplemental-module-scss-module__ZFQVQq__taxMessageInfo",
});
